import { render, staticRenderFns } from "./EditIsolation.vue?vue&type=template&id=25149f9f"
import script from "./EditIsolation.vue?vue&type=script&lang=js"
export * from "./EditIsolation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports